module.exports = __webpack_public_path__ + "static/media/card-self-awareness.c07a1146.svg";